
import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import PlanSettings from './pages/PlanSettings';
import Dashboard from './pages/Dashboard';
import LlmPage from './pages/LlmPage';

import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';

const AppContent: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsTransitioning(true);
    const timer = setTimeout(() => {
      setIsTransitioning(false);
    }, 200);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/plansv2" element={<LlmPage />} />
        <Route path="*" element={<Navigate to="/plansv2" replace />} />
      </Routes>
    );
  }

  return (
    <div className="flex h-screen bg-brand-white dark:bg-black overflow-hidden font-sans text-slate-900 transition-colors duration-300 w-full max-w-full">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden relative w-full">
        <Topbar toggleSidebar={() => setCollapsed(!collapsed)} collapsed={collapsed} />

        <main className={`flex-1 overflow-y-auto overflow-x-hidden custom-scrollbar bg-brand-white dark:bg-black transition-all duration-300 ease-in-out ${isTransitioning ? 'opacity-0 translate-x-4' : 'opacity-100 translate-x-0'} w-full`}>
          <div className="min-w-0 h-full w-full max-w-full">
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="*" element={<LlmPage />} />
            </Routes>
          </div>
        </main>
      </div>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </LanguageProvider>
  );
};

export default App;
